import styled, { css } from 'styled-components';
import { themes } from 'styles/themes/wikifactoryNew';

const ICON_SIZE = 32;

export const NewWrapper = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 2px;
  font-size: ${props => props.theme.font.size.default};
  color: ${props => props.theme.color.wfGrey400};
  pointer-events: auto;
  background: white;
  min-width: 250px;
`;

export const ModesGroup = styled.div`
  display: grid;
  grid-template-columns: 50% 50%;
  align-items: center;
`;

export const ModeStyled = styled.div`
  display: grid;
  pointer-events: ${props => (props.disable ? 'none' : 'auto')};
  grid-template-columns: 18px auto;
  padding: 0px 3px;
  align-items: center;
  &:not(:first-of-type) {
    border-left: 1px solid ${props => props.theme.color.wfGrey200};
  }
  border-bottom: 1px solid white;
  border-color: ${props =>
    props.active ? props.theme.color.wfWhite : props.theme.color.wfGrey200};
  background: ${props =>
    props.active ? props.theme.color.wfWhite : props.theme.color.wfGrey100};
  color: ${props =>
    props.active ? props.theme.color.wfGrey : props.theme.color.wfGrey600};

  &:hover {
    color: ${props => props.theme.color.primary};
    cursor: pointer;
  }
`;

export const FromToWrapper = styled.div`
  display: flex;
  width: 100%;
  padding: 0 0.5rem;
  align-items: center;
  height: ${ICON_SIZE}px;
  font-size: ${props => props.theme.font.size.small};
  color: ${props => props.theme.color.wfGrey600};
  border-top: 1px solid ${props => props.theme.color.wfGrey200};
`;

export const TargetIcon = styled.div`
  display: flex;
  align-items: center;
  width: ${ICON_SIZE}px;
  color: ${props =>
    props.active
      ? props.isTemp
        ? props.theme.color.wfBlue900
        : props.theme.color.wfBlack
      : props.theme.color.wfGrey600};
  justify-content: center;
  &:hover {
    color: ${props => props.theme.color.black};
    cursor: crosshair;
  }
  margin: 0 2px;
  padding: 0;
`;

export const NewOptionWrapper = styled.div`
  display: grid;
  grid-template-columns: 24px auto;
  padding: 4px;
  align-items: center;
  color: ${props => props.theme.color.wfGrey};
`;

export const OptionsWrapper = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  color: ${props => props.theme.color.wfGrey};
  background: ${props => props.theme.color.wfGrey100};
  border-top: 1px solid ${props => props.theme.color.wfGrey200};
  overflow: visible;
  z-index: 10;
`;

export const OptionsGroup = styled.div`
  display: flex;
  position: relative:
  margin-right: ${props => (props.atRight ? '0' : 'auto')};
  margin-left: ${props => (props.atRight ? 'auto' : '0')};
  &:not(:first-of-type) {
    border-left: 1px solid ${props => props.theme.color.wfGrey200};
  }
`;

export const InfoWrapper = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  color: ${props => props.theme.color.wfGrey};
  background: ${props => props.theme.color.wfBlue100};
  border-top: 1px solid ${props => props.theme.color.wfGrey200};
  overflow: visible;
  z-index: 10;
`;

export const MouseIcon = styled.div`
  display: flex;
  align-items: center;

  ${props =>
    props.onClick != null &&
    css`
      cursor: pointer;
      color: ${props.theme.color.wfBlack};
    `}
`;

export const OptionIcon = styled.div`
  align-items: center;
  justify-content: center;
  margin: ${props => (props.tight ? '0' : '0 0.2rem')};
  padding: ${props => (props.tight ? '0' : '0.25rem 0')};
  display: ${props => (props.hide ? 'none' : 'flex')};

  color: ${props =>
    props.active
      ? props.theme.color.wfBlack
      : props.atRight || props.alwaysActive
      ? props.theme.color.wfGrey
      : props.theme.color.wfGrey600};

  &:hover {
    color: ${props => (props.disabled ? 'inherit' : props.theme.color.primary)};
    cursor: ${props => (props.disabled ? 'auto' : 'pointer')};
  }
`;

export const MeasureItemStyled = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  font-size: ${props => props.theme.font.size.default};

  color: ${props =>
    props.selected
      ? props.theme.color.wfPurple
      : props.highlighted
      ? props.theme.color.wfBlue
      : props.theme.color.wfGrey};

  &:hover {
    cursor: ${props => (props.isTemp ? 'auto' : 'pointer')};
  }

  pointer-events: auto;
`;

export const MeasureItemIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${ICON_SIZE}px;

  color: ${props => (props.disabled ? props.theme.color.wfGrey600 : 'inherit')};

  margin: 0;
`;

export const MeasureItemProjection = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  color: ${props => (props.isProj ? props.theme.color.wfGrey600 : 'inherit')};
`;

export const MeasureItemValue = styled.div`
  display: flex;
  color: ${props =>
    props.isProj || props.disabled ? props.theme.color.wfGrey600 : 'inherit'};
  font-size: ${props => (props.small ? '0.875rem' : '1rem')};
  text-decoration: ${props =>
    props.isStrikeThrough ? 'line-through' : 'none'};
`;

export const MeasureItemActions = styled.div`
  display: flex;
  position: absolute;
  right: 2px;
  padding: 0.5rem;
`;

export const MeasureItemDeleteWrapper = styled.div`
  display: flex;
  color: ${props => props.theme.color.wfGrey};
  &:hover {
    cursor: pointer;
    color: ${props => props.theme.color.red};
  }
`;
